/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const VolumeLow: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="volume-low" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M340 453.3333333333334V793.3333333333334A113.3333333333333 113.3333333333333 0 0 0 453.3333333333333 906.6666666666669H623.3333333333333L963.3333333333331 1246.6666666666667V113.3333333333335L623.3333333333333 453.3333333333334H340zM850 971.8333333333334L671.5 793.3333333333334H453.3333333333333V566.6666666666667H671.5L850 388.1666666666668V971.8333333333334z" : "M272 362.6666666666667V634.6666666666666A90.6666666666667 90.6666666666667 0 0 0 362.6666666666667 725.3333333333333H498.6666666666667L770.6666666666667 997.3333333333334V90.6666666666666L498.6666666666667 362.6666666666667H272zM680 777.4666666666667L537.2 634.6666666666666H362.6666666666667V453.3333333333333H537.2L680 310.5333333333333V777.4666666666667z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
VolumeLow.displayName = `Blueprint5.Icon.VolumeLow`;
export default VolumeLow;
